import { useEffect } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { loginUser } from '../services/Login_service';
import '../css/login.css';
import logo from '../image/logo.png';
import test1 from '../image/image.gif';
import img1 from '../image/AloLogo/logo2.png';
import img2 from '../image/AloLogo/logo3.png';
import img3 from '../image/AloLogo/logo4.png';
import img4 from '../image/AloLogo/logo5.png';
import img5 from '../image/AloLogo/logo7.png';
import img6 from '../image/AloLogo/logo10.png';

import img7 from '../image/AloLogo/logo15.png';
import img8 from '../image/AloLogo/logo16.png';
import img9 from '../image/AloLogo/logo18.png';
import img10 from '../image/AloLogo/logo19.png';
import img11 from '../image/AloLogo/logo20.png';
import img12 from '../image/AloLogo/logo21.png';

import img13 from '../image/AloLogo/logo22.png';
import img14 from '../image/AloLogo/logo23.png';
import img15 from '../image/AloLogo/logo24.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navigate, useNavigate } from 'react-router-dom';
import { faNewspaper, faGaugeHigh } from '@fortawesome/free-solid-svg-icons';

const FreeLogin = () => {

    const navigate = useNavigate();

    useEffect(() => { 
        const authenticate = async () => {
            try{
                let user = await loginUser( "client@gmail.com", "client123" );
                if (user) {
                    setTimeout(() => {
                        navigate('/home', { replace: true })
                    }, 2000 )
                }
            } catch( error ){
                console.log( "login error ", error )
            }

        }
        if( !localStorage.getItem("userId") ){ authenticate() }
        else { navigate('/home', { replace: true })}
    }, [])

    return (
        <>
            <ToastContainer />

            <div className="degrade-vertical big-height">
                {/* logo */}
                <div className="row col-section d-flex justify-content-center align-items-center ">

                    <div className="col-12 col-md-6 col-lg-6 d-flex section-txt mt-5">
                        <div className="bg-section section-tab">
                            <div className="img-animate">
                                <img src={test1} alt="png" className="img-fluid w-75  mb-3 ImgGif" />
                            </div>
                            <div className="row">
                                <div className="col-md-8 justify-content-center align-items-center">
                                    
                                </div>
                            </div>
                            <div className="text-title mt-3 ">
                                <h1 className="font-1 mt-3">Annonce Legale Officielle</h1>
                                <p className="font-2 ">Bénéficiez d’une publication instantanée dans toute la France,
                                    grâce à notre plateforme sécurisée en ligne, disponible 24/7 et adaptée à tout type
                                    d’annonce, des plus simples aux plus complexes.</p>
                                <div className="subtile-item mt-3 d-flex">
                                    <div className="text-subtitle-icon fs-4 ">
                                        <FontAwesomeIcon icon={faNewspaper} aria-hidden="true" />
                                    </div>
                                    <div className="text ms-3">
                                        <h3 className="fs-5 text-subtitle">Choix du journal</h3>
                                        <p className="font-2 fonts">Vous souhaitez choisir votre support de publication ?
                                            Notre outil vous offre le plus large choix de journaux digitaux et papier
                                            habilités en France.</p>
                                    </div>
                                </div>
                                <div className="subtile-item mt-3 d-flex">
                                    <div className="text-subtitle-icon fs-4 ">
                                        <FontAwesomeIcon icon={faGaugeHigh} aria-hidden="true" />
                                    </div>
                                    <div className="text ms-3">
                                        <h3 className="fs-5 text-subtitle">Attestation immédiate</h3>
                                        <p className="font-2 fonts">Quelle que soit l’urgence de votre dossier, en utilisant
                                            notre solution, l’attestation de publication est disponible immédiatement
                                            avec le choix sur la méthode de facturation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-6 d-flex bg-dark-login section-txt">

                        <div className="p-3 logo">
                            <img src={logo} className="my-2 ml-3 logo-1" alt="logo" />
                        </div>

                        <div className="bg-white p-5 d-flex justify-content-center align-items-center gap-5 border-radius-2">
                            <span className="dots-loader-text"> Authentification </span><div className="green dots-loader mb-2"></div>
                        </div>

                        {/* <div className="row"> */}

                            <div className="grid text-center mt-3">
                                <div>
                                    <img src={img1} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img2} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img3} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img4} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img5} alt="png" className="img-fluid w-75" />
                                </div>
                            </div>

                            <div className="grid text-center">
                                <div>
                                    <img src={img6} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img7} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img8} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img9} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img10} alt="png" className="img-fluid w-75" />
                                </div>
                            </div>

                            <div className="grid text-center">
                                <div>
                                    <img src={img11} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img12} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img13} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img14} alt="png" className="img-fluid w-75" />
                                </div>
                                <div>
                                    <img src={img15} alt="png" className="img-fluid w-75" />
                                </div>
                            </div>

                        </div>
                </div>

            </div>
        </>
    );
};

export default FreeLogin;